import Image from "next/image";

import classNames from "classnames";
import useViewport from "hooks/useViewport";

const ThumbnailBanner = (props) => {
  const {
    rounded,
    imageURL,
    className,
    iconURL,
    imageAltText,
    iconClickHandler,
  } = props;
  const { width: windowWidth } = useViewport();
  const isMobile = windowWidth < 1024;

  return (
    <div
      className={classNames(
        {
          "overflow-hidden rounded-xl md:rounded-2xl": rounded,
        },
        {
          relative: !!iconURL,
        },
        `${className}`
      )}
    >
      <div className="relative w-[23.875rem] md:w-[32rem] lg:w-[42rem] xl:w-[54.125rem] aspect-video">
        <Image
          src={imageURL}
          alt={imageAltText}
          fill
          quality={30}
          className="object-cover"
        />
      </div>

      {iconURL && (
        <div
          role="button"
          className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 transform items-center justify-center rounded-full bg-white/30"
        >
          <Image
            alt="icon"
            src={iconURL}
            onClick={iconClickHandler}
            width={isMobile ? 50 : 106}
            height={isMobile ? 50 : 106}
            quality={30}
          />
        </div>
      )}
    </div>
  );
};

export default ThumbnailBanner;
